function initializeProduct(root = document) {
  const form = root.querySelector('#ProductForm');
  if (form?.dataset.initialized) return;
  if (form) form.dataset.initialized = 'true';
  const gallery = root.querySelector('[data-gallery]');
  function showImage(id) {
    if (!gallery || !Array.from(gallery.children).some(image => image.id === id)) return;
    for (const image of gallery.children) image.hidden = image.id !== id;
    for (const button of root.querySelectorAll('[data-image-target]')) button.setAttribute('aria-pressed', String(button.dataset.imageTarget === id));
  }
  for (const button of root.querySelectorAll('[data-image-target]')) button.addEventListener('click', () => showImage(button.dataset.imageTarget));
  const select = root.querySelector('[data-variant-select]');
  const add = root.querySelector('[data-add-to-bag]');
  function syncVariant(updateUrl = false) {
    if (!select || !add) return;
    const option = select.selectedOptions[0];
    if (!option) return;
    root.querySelector('[data-product-price]').textContent = option.dataset.price;
    add.disabled = option.dataset.available !== 'true';
    add.textContent = add.disabled ? 'Sold out' : 'Add to bag';
    showImage(option.dataset.image);
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    }
  }
  if (select && add) {
    select.addEventListener('change', () => syncVariant(true));
    syncVariant();
    window.addEventListener('pageshow', () => syncVariant());
  }
}
initializeProduct();
document.addEventListener('shopify:section:load', event => initializeProduct(event.target));
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  for (const menu of document.querySelectorAll('.mobile-menu[open], .owner-menu[open]')) {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  }
});
